<template>
  <NotificationsSettings />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import NotificationsSettings from "@/components/content/NotificationsSettings.vue";

export default defineComponent({
  name: 'NotificationSettingsView',
  components: {NotificationsSettings},

  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.notificationSettings'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.notificationSettings'))
    })
  }
})
</script>